import { useState, useEffect } from 'react'
import { debounce } from 'es-toolkit'

const useScrollSpy = (sectionIds: string[], offset = 100) => {
  const [activeId, setActiveId] = useState('')

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = Math.ceil(window.scrollY + offset + 10)

      // 遍历所有section，找到当前可视区域内的section
      for (let i = sectionIds.length - 1; i >= 0; i--) {
        const section = document.getElementById(sectionIds[i])
        if (section) {
          const offsetTop = Math.ceil(section.getBoundingClientRect().top + window.scrollY)
          if (scrollPosition >= offsetTop) {
            setActiveId(sectionIds[i])
            break
          }
        }
      }
    }

    // 初始化时执行一次
    handleScroll()

    // 创建debounce函数并保存引用，确保能正确移除监听器
    const debouncedHandleScroll = debounce(handleScroll, 50)
    window.addEventListener('scroll', debouncedHandleScroll)

    return () => {
      window.removeEventListener('scroll', debouncedHandleScroll)
    }
  }, [sectionIds, offset])

  return activeId
}

export { useScrollSpy }
